import { render } from "./BusinessCaseComparison.vue?vue&type=template&id=94913398"
import script from "./BusinessCaseComparison.vue?vue&type=script&lang=js"
export * from "./BusinessCaseComparison.vue?vue&type=script&lang=js"

import exportComponent from "D:\\agents\\Oreo\\_work\\93\\s\\NcasReporting\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__